import { render, staticRenderFns } from "./ShowClientPortal.vue?vue&type=template&id=1b43d73a&"
import script from "./ShowClientPortal.vue?vue&type=script&lang=js&"
export * from "./ShowClientPortal.vue?vue&type=script&lang=js&"
import style0 from "./ShowClientPortal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem,VTabsItems})
